import React from "react";

export const Types01: React.FC = () => {
  return (
    <div id="types" className="types01-section">
      <div className="moreinfo-container">
        <div className="types01-wrapper">
          <div className="types01-left-column">
            <h2 className="moreinfo-title moreinfo-title-blue moreinfo-title-left">Tipos de endo</h2>
            
            <p className="moreinfo-text types01-subtitle">
              Existen tres formas de presentación de la enfermedad.
            </p>
            
            <ul className="types01-list">
              <li className="types01-list-item">
                <span className="moreinfo-highlight-blue types01-type-name">SUPERFICIAL:</span> Este es el tipo de endometriosis más prevalente. Se define como "un nódulo/lesión
                de endometriosis de menos de 5 mm de profundidad".
              </li>
            </ul>
            
            <p className="moreinfo-text">
              Suele ser relativamente fácil de extirpar y tratar. Sin embargo el aspecto de las lesiones puede variar y una endometriosis sutil puede pasar
              desapercibida ante ojos no expertos.
            </p>
            
            <ul className="types01-list">
              <li className="types01-list-item">
                <span className="moreinfo-highlight-blue types01-type-name">PROFUNDA:</span> Se define como "un nódulo/lesión de endometriosis de más de 5 mm de profundidad. Suele
                afectar al peritoneo (revestimiento de la pelvis), los ligamentos, el intestino y la vejiga.
              </li>
            </ul>
            
            <p className="moreinfo-text">
              Este tipo de endometriosis puede ser difícil de tratar y los pacientes deben ser atendidos, idealmente, en un centro especializado
              en la patología con un equipo multidisciplinar.
            </p>
          </div>
          
          <div className="types01-right-column">
            <div className="types01-main-image-container">
              <img
                src="img/type1.svg"
                className="moreinfo-image"
                alt="Superficial"
              />
              <img
                src="img/type2.webp"
                className="moreinfo-image types01-second-image"
                alt="Profunda"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};